/* tslint:disable */
/* eslint-disable */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type TemplateIndexQueryVariables = {
    count: number;
    cursor?: string | null;
};
export type TemplateIndexQueryResponse = {
    readonly " $fragmentRefs": FragmentRefs<"TemplateIndex_query">;
};
export type TemplateIndexQuery = {
    readonly response: TemplateIndexQueryResponse;
    readonly variables: TemplateIndexQueryVariables;
};



/*
query TemplateIndexQuery(
  $count: Int!
  $cursor: String
) {
  ...TemplateIndex_query_1G22uz
}

fragment DraftableCell_draftable on Draftable {
  __isDraftable: __typename
  __typename
  ... on Node {
    __isNode: __typename
    id
  }
  latestDraft {
    publishedAt
    scheduledFor
    updatedAt
    publicationStatus
    administrators {
      user {
        id
        first_name
        last_name
        avatar_url
      }
    }
    draftable {
      __typename
      name
      ... on Slugable {
        __isSlugable: __typename
        thumbnails(aspect_ratio: SQUARE) {
          small
        }
      }
      ... on Node {
        __isNode: __typename
        id
      }
    }
    id
  }
}

fragment TemplateIndex_query_1G22uz on Query {
  organization {
    id
    templates(first: $count, after: $cursor) {
      edges {
        node {
          id
          ...DraftableCell_draftable
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "count"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cursor"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TemplateIndexQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          {
            "kind": "Variable",
            "name": "cursor",
            "variableName": "cursor"
          }
        ],
        "kind": "FragmentSpread",
        "name": "TemplateIndex_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TemplateIndexQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "organization",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "TemplateConnection",
            "kind": "LinkedField",
            "name": "templates",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TemplateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Template",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v3/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Draft",
                            "kind": "LinkedField",
                            "name": "latestDraft",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "publishedAt",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "scheduledFor",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "updatedAt",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "publicationStatus",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "DraftAdministrator",
                                "kind": "LinkedField",
                                "name": "administrators",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                      (v1/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "first_name",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "last_name",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "avatar_url",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "draftable",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "name",
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": [
                                          {
                                            "kind": "Literal",
                                            "name": "aspect_ratio",
                                            "value": "SQUARE"
                                          }
                                        ],
                                        "concreteType": "Thumbnail",
                                        "kind": "LinkedField",
                                        "name": "thumbnails",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "small",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": "thumbnails(aspect_ratio:\"SQUARE\")"
                                      }
                                    ],
                                    "type": "Slugable",
                                    "abstractKey": "__isSlugable"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v1/*: any*/)
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                  }
                                ],
                                "storageKey": null
                              },
                              (v1/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isNode"
                          }
                        ],
                        "type": "Draftable",
                        "abstractKey": "__isDraftable"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v2/*: any*/),
            "filters": null,
            "handle": "connection",
            "key": "TemplateIndex_templates",
            "kind": "LinkedHandle",
            "name": "templates"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "013f9e2f6db07a60ada36ad2a0eb1308",
    "id": null,
    "metadata": {},
    "name": "TemplateIndexQuery",
    "operationKind": "query",
    "text": "query TemplateIndexQuery(\n  $count: Int!\n  $cursor: String\n) {\n  ...TemplateIndex_query_1G22uz\n}\n\nfragment DraftableCell_draftable on Draftable {\n  __isDraftable: __typename\n  __typename\n  ... on Node {\n    __isNode: __typename\n    id\n  }\n  latestDraft {\n    publishedAt\n    scheduledFor\n    updatedAt\n    publicationStatus\n    administrators {\n      user {\n        id\n        first_name\n        last_name\n        avatar_url\n      }\n    }\n    draftable {\n      __typename\n      name\n      ... on Slugable {\n        __isSlugable: __typename\n        thumbnails(aspect_ratio: SQUARE) {\n          small\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment TemplateIndex_query_1G22uz on Query {\n  organization {\n    id\n    templates(first: $count, after: $cursor) {\n      edges {\n        node {\n          id\n          ...DraftableCell_draftable\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'ef73a2028184b77e29200ae744d62b03';
export default node;
